import { render, staticRenderFns } from "./CampaignStat.vue?vue&type=template&id=b185668a&scoped=true&"
import script from "./CampaignStat.vue?vue&type=script&lang=js&"
export * from "./CampaignStat.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStat.vue?vue&type=style&index=0&id=b185668a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b185668a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VCard,VCardTitle,VIcon,VProgressCircular,VSimpleTable,VTab,VTabs,VTabsSlider})
